module.exports = __webpack_public_path__ + "static/media/N2.fba7ccbe.png";